import { useEffect, useMemo, useState } from "react";
import BhfCreate from "./BhfCreate";
import BhfUpdate from "./BhfUpdate";
import BhfInaktiv from "./BhfInaktiv";
import { bhfHeader, csvHeaderBhf } from "../Tabellen/ConstTabKopf/BahnhofKopf";
import GeneralTable from "../Tabellen/GeneralTable";
import DatenLaden from "../Tabellen/DatenLaden";
import InformationCell from "../Tabellen/InformationCell";
import { FehlerauswertungErrResp } from "../Fehler/FehlerauswertungErrResp";
import StammdatenExport from "../Stammdaten/StammdatenExport";

export default function BhfLaden({ instance, katInstance, typInstance, zvInstance, setTable, goBack }) {
    const [data, setData] = useState(null);
    const [columns, setColumns] = useState(null);
    const [kategorien, setKategorien] = useState();
    const [typen, setTypen] = useState();
    const [zweckverbaende, setZweckverbaende] = useState();

    const reloadData = () => {
        setData();
        let reloadTable = new Promise((result) =>
            instance.getBahnhofBahnhofGet((error, data, response) => {
                if (error) {
                    console.error(error);
                } else {
                    console.log(data);
                    data.forEach(element => {
                        if (element.gueltig_von) {
                            element.gueltig_von = element.gueltig_von.toLocaleDateString();
                        }
                        if (element.gueltig_bis) {
                            element.gueltig_bis = element.gueltig_bis.toLocaleDateString();
                        }
                    });
                    result(data);
                }
            })
        )
        reloadTable.then(msg => {
            setData(msg);
        })
    }
    useEffect(() => {
        instance.getBahnhofBahnhofGet((error, data, response) => {
            if (error) {
                FehlerauswertungErrResp(error, response);
            } else {
                data.forEach(element => {
                    if (element.gueltig_von) {
                        element.gueltig_von = element.gueltig_von.toLocaleDateString();
                    }
                    if (element.gueltig_bis) {
                        element.gueltig_bis = element.gueltig_bis.toLocaleDateString();
                    }
                });
                setData(data);
                setColumns(bhfHeader);
            }
        });

        katInstance.getBahnhofkategorieBahnhofkategorieGet((error, data, response) => {
            if (error) {
                console.error(error);
            } else {
                setKategorien(data);
            }
        });
        typInstance.getBahnhoftypBahnhoftypGet((error, data, response) => {
            if (error) {
                console.error(error);
            } else {
                setTypen(data);
            }
        });
        let opts = {
            'onlyActive': false // Boolean | 
        };
        zvInstance.getZweckverbandZweckverbandGet(opts, (error, data, response) => {
            console.log('zv laden')
            if (error) {
                console.error(error);
            } else {
                setZweckverbaende(data);
            }
        });

    }, [instance, katInstance, typInstance, zvInstance])

    const prepData = useMemo(() => data, [data]);
    const additionalColumn =
    {
        id: "update",
        Header: '',
        keyword: 'Änderungen',
        Cell: ({ row }) => (
            <div>
                <BhfUpdate rowEntry={row} reloadData={reloadData} instance={instance} kategorien={kategorien} typen={typen} zweckverbaende={zweckverbaende} />
            </div>
        )
    }
    const commCol = {
        id: "comment",
        Header: "",
        keyword: "Info",
        Cell: ({ row }) => (
            <div>
                <InformationCell comment={row.original.kommentar} />
            </div>
        )
    }

    const deleteSpecificRow = idBhf => {
        console.log("ans BE: sperre ", idBhf);
        instance.lockBahnhofPatch(idBhf, (error, data, response) => {
            if (error) {
                FehlerauswertungErrResp(error, response);
                console.log(error);
            } else {
                reloadData();
            }
        })
    }

    const delCol = {
        id: "del",
        Header: '',
        keyword: "del",
        Cell: ({ row }) => (
            <div>
                <BhfInaktiv rowEntry={row.original} deleteSpecificRow={deleteSpecificRow} />
            </div>
        )
    }

    const csvIt = loadedData => {
        return loadedData.map(it =>
        ({
            ...it,
            Bahnhof: it.bahnhof,
            Abkürzung: it.kurz,
            'x-Koordinate': it.xkoord,
            'y-Koordinate': it.ykoord,
            Bahnhofstyp: it.korr_typ,
            Bahnhofskategorie: it.korr_kat,
            Zweckverband: it.korr_zv,
            Gültigkeitsbeginn: it.gueltig_von,
            Gültigkeitsende: it.gueltig_bis,
            Kommentar: it.kommentar
        }))
    }
    return (
        <>
            <BhfCreate instance={instance} katInstance={katInstance} typInstance={typInstance} zvInstance={zvInstance} reloadData={reloadData} />
            {data && columns && kategorien && typen && zweckverbaende
                ? <div>
                    <GeneralTable data={prepData} reloadData={reloadData} columns={columns} hiddenColumns={['id', 'id_kat', 'id_typ', 'id_zv', 'kommentar']} additionalColumns={[commCol, additionalColumn, delCol]} />
                    <StammdatenExport csvedData={csvIt(prepData)} csvHeader={csvHeaderBhf} csvFilename={"sd_bhf"} />
                </div>
                : <DatenLaden />}
        </>
    );
}